<template>
    <div class="vtrend-licheng">
        <!-- <Echart :id="'siteVtrendLicheng'" :options="options" :width="width" :height="height"></Echart> -->
        <div :id="id"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts5'
export default {
    props: {
        id: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: () => { return [] }
        },
        xData: {
            type: Array,
            default: () => { return [] }
        },
        colors: {
            type: Array,
            default: () => { return [] }
        },
    },
    data() {
        return {
            options: {
                grid: {
                    left: '3%',
                    right: '8%',
                    bottom: '10%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {//x轴文字的配置
                        show: true,
                        fontSize: 20,
                        textStyle: {
                            color: "#fff",
                        }
                    },
                    data: this.xData
                } ],
                yAxis: [{
                    type: 'value',
                    axisLabel: {//x轴文字的配置
                        show: true,
                        fontSize: 20,
                        textStyle: {
                            color: "#fff",
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ["rgba(255, 255, 255, 0.15)"]
                        }
                    }
                }],
                series: [{
                    name: 'Line 1',
                    type: 'line',
                    stack: 'Total',
                    smooth: true,
                    lineStyle: {
                        width: 0
                    },
                    showSymbol: false,
                    areaStyle: {
                        opacity: 0.3,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 0.5, [
                            {
                                offset: 0,
                                color: this.colors[0] || '#36A1FF'
                            },
                            {
                                offset: 1,
                                color: this.colors[1] || '#1968FF'
                            }
                        ])
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: this.data
                }]
            }
        }
    },
    mounted() {
        this.myCharts()
    },
    methods: {
        myCharts() {
            const _this = this
            const myCharts = echarts.init(document.getElementById(_this.id))
            
            myCharts.setOption(_this.options)
        }
    }
}
</script>

<style lang="scss" scoped>
.vtrend-licheng {
    width: 100%;
    height: 100%;
    > div {
        width: 100%;
        height: 100%;
    }
}
</style>